const API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const getAddress = async (lat, long) => {
    return await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${API_KEY}`).then(
        (res) => res.json()
    );
};

export const getLocation = async (address) => {
    const geocoder = new window.google.maps.Geocoder();
    let result;
    await geocoder.geocode({ address: address }, function (results, status) {
        if (status === "OK") {
            result = results[0];
        }
    });

    return result;
};
